(ns net.kestec.mhda-pilgrimage.public.dashboard
  (:require
    ["@mui/material/Grid2" :default Grid]
    [day8.re-frame.http-fx]
    [net.kestec.mhda-pilgrimage.db :as db]
    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]
    [net.kestec.mhda-pilgrimage.public.news.widgets.global-news-block :refer [global-news-block]]
    [net.kestec.mhda-pilgrimage.public.application.widgets.onboard-action-block :refer [onboard-action-block]]
    [net.kestec.mhda-pilgrimage.route :as route]
    [re-frame.core :as rf]

    ))


(defn main []
  (if-not (db/has-session?)
    ;[:pre (pr-str @(rf/subscribe [::db/get ::db/me]))] ;
    (rf/dispatch [::route/push ::route/public.landing])
    [base-page
     [:<>
      [:> Grid {:container true :direction "row" :spacing 1}
       [:> Grid {:size {:xs 12}}
        [:> Grid {:container true :direction "row" :spacing 1}
         [:> Grid {:size {:xs 12 :md 12}}
          [onboard-action-block]
          [global-news-block]
          ]
         ]]
       ]

      ]]))


